exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sectionItem[data-v-d0e7325a]{margin:30px 0}.supporters[data-v-d0e7325a]{padding:0;margin:30px 0 0;list-style:none}.logoImg[data-v-d0e7325a]{width:200px;height:auto}", ""]);

